exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-facial-record-wrapper[data-v-43fcec2a]{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-43fcec2a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UserManage/UserManage/UploadFacialRecord.vue
// module id = 509
// module chunks = 0